<template>
  <div>
    <Input
      @on-clear="clear"
      v-model="nameHand"
      :clearable="clearable"
      :readonly='!isHand'
      placeholder="请输入"
      ><Button slot="append" icon="md-person" @click="openUser = true"> </Button
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openUser"
      draggable
      class="my-drawer"
      width="300"
    >
      <userTree :keyword="keyword" @user="reUser"></userTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement", "keyword","isHand","clearable"],
  data() {
    return {
      openUser: false,
      nameHand: "",
    };
  },
  methods: {
    reUser(v) {
      this.openUser = false;
      this.$emit("update:id", v.id);
      this.$emit("update:account", v.account);
      this.$emit("update:accountId", v.accountId);
      this.$emit("update:name", v.name);
      this.$emit("user", v);
    },
    clear() {
      this.$emit("update:id", "");
      this.$emit("update:account", "");
      this.$emit("update:accountId", "");
      this.$emit("update:name", "");
    },
  },
   watch: {
    name(v) {
      this.nameHand = v;
    },
    nameHand(v) {
      this.$emit("update:name", v);
    },
  },
  mounted() {
    this.nameHand = this.name;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectUser.vue